// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dialga_origin: PokeData = {
  "id": 10245,
  "name": "dialga-origin",
  "height": 70,
  "weight": 8487,
  "base_experience": 306,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slash",
    "scary-face",
    "dragon-breath",
    "iron-tail",
    "metal-claw",
    "ancient-power",
    "dragon-claw",
    "metal-burst",
    "aura-sphere",
    "power-gem",
    "earth-power",
    "flash-cannon",
    "roar-of-time"
  ],
  "moves": [
    "scary-face",
    "dragon-breath",
    "metal-claw",
    "ancient-power",
    "dragon-claw",
    "metal-burst",
    "earth-power",
    "metal-sound",
    "great-roar",
    "magnet-bomb",
    "dragon-dance",
    "scale-shot",
    "metal-rush"
  ],
  "evolution_chain": {
    "id": 244,
    "item": null,
    "species": [
      {
        "name": "dialga",
        "order": 484,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 103,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
